import React, { Component } from 'react'
import isEmpty from 'validator/lib/isEmpty'

import StyledInput from './StyledInput'
import withSpacing from './WithSpacing'

interface InputProps {
  error?: string
  id: string
  isMultiline?: boolean
  isRequired?: boolean
  label?: string
  placeholder?: string
  registerInputCallback(...args: unknown[]): unknown
  render?(...args: unknown[]): unknown
  validateOverride?(...args: unknown[]): unknown
  valueOverride?(...args: unknown[]): unknown
}

class Input extends Component<InputProps> {
  ref: any

  constructor(props: any) {
    super(props)

    this.state = {
      value: '',
      error: ''
    }

    this.ref = React.createRef()

    this.onSetOverrideValidation = this.onSetOverrideValidation.bind(this)
    this.updateFromChild = this.updateFromChild.bind(this)
  }

  componentDidMount() {
    const { registerInputCallback } = this.props
    registerInputCallback(this)
  }

  validate() {
    const value = this.value()

    let overallErrorMessage = ''
    // TODO There may be a use for running `checkValidity()` here in the future
    // We do isRequired validation for everyone
    let isValid = false
    if (typeof value === 'number') {
      // Since we only check isRequired at this generic input level, if it's a number it's always valid
      isValid = true
    } else {
      isValid = !!((this.props.isRequired && value != null && !isEmpty(value)) || !this.props.isRequired)
    }

    if (!isValid) {
      overallErrorMessage = 'Required'
    }

    // Run any custom validations
    if (this.props.validateOverride) {
      const errorFromCustomValidation = this.props.validateOverride(value, this.ref.current)
      if (errorFromCustomValidation) {
        isValid = false
        // @ts-expect-error
        overallErrorMessage = errorFromCustomValidation
      }
    }

    this.setState({
      error: overallErrorMessage
    })

    return isValid
  }

  onSetOverrideValidation(fn: any) {
    this.onSetOverrideValidation = fn
  }

  updateFromChild(value: any) {
    this.setState({
      value
    })
  }

  value() {
    if (this.props.valueOverride) {
      // @ts-expect-error
      return this.props.valueOverride(this.state.value)
    }
    // @ts-expect-error
    return this.state.value
  }

  id() {
    return this.props.id
  }

  // @ts-expect-error
  render() {
    const { isRequired, label, isMultiline, render, error: errorFromProps } = this.props
    // @ts-expect-error
    const { value, error } = this.state

    const as = isMultiline ? 'textarea' : 'input'
    const totalError = error || errorFromProps

    if (render) {
      return render(this.updateFromChild, value, totalError, { ...this.props })
    } else {
      return (
        <StyledInput
          {...this.props}
          label={label}
          // @ts-expect-error
          as={as}
          ref={this.ref}
          value={value}
          error={totalError}
          required={isRequired}
          onChange={(e: any) => this.setState({ value: e.target.value, error: '' })}
        />
      )
    }
  }
}

export default withSpacing(Input)
export { Input }
